/** Shared fax review state for the order's document icons and completion validation. */
import React, { createContext, useContext } from "react";
import {
  OrderFaxLettersState,
  useOrderFaxLetters,
} from "../pages/worklists/singleOrder/cptCodes/hooks/useOrderFaxLetters";
import { useDataAccumulatorForSingleOrder } from "./dataAccumulatorForSingleOrder";

const OrderFaxLettersContext = createContext<OrderFaxLettersState>({
  byJCodeId: new Map(),
  status: "idle",
});

/** Load once for the order layout; refresh when the saved auth data changes. */
export const OrderFaxLettersProvider = ({
  orderId,
  orgId,
  children,
}: {
  orderId: string;
  orgId: string;
  children: React.ReactNode;
}) => {
  const { authOnFileDetails } = useDataAccumulatorForSingleOrder();
  const state = useOrderFaxLetters(orderId, orgId, authOnFileDetails);
  return (
    <OrderFaxLettersContext.Provider value={state}>
      {children}
    </OrderFaxLettersContext.Provider>
  );
};

/** Read the same scoped result used for the Drugs tab's fax document icon. */
export const useOrderFaxLettersContext = () =>
  useContext(OrderFaxLettersContext);
